module.exports = __webpack_public_path__ + "images/travelcare_small012aee1129c5d66c0bd6dc0c6480bdb4.png";